@let _contentComponent = contentComponent();
@let _contentTemplate  = contentTemplate();
@let _contentString    = contentString();

<div class="modal-window" [ngStyle]="cssStyle()" [ngClass]="cssClass()" [class.fullscreen]="options().fullscreen">
  @if (_contentComponent) {
    <ng-container *ngComponentOutlet="_contentComponent; inputs: getModalInputs(options().data)"></ng-container>
  }
  @else if (_contentTemplate) {
    <ng-container *ngTemplateOutlet="_contentTemplate"></ng-container>
  }
  @else if (_contentString) {
    {{_contentString}}
  }

  <div class="head-container">
    @if (options().showDisableAds) {
      <a [routerLink]="'/account/subscription'" target="_blank" class="primary-link disable-ads-button">
        <app-svg-icon name="fire"></app-svg-icon>
        <span>Отключить рекламу</span>
      </a>
    }

    @if (options().showClose) {
      <button class="modal-close icon-button" [class.with-btn]="options().showDisableAds" (click)="close()">
        <app-svg-icon [name]="options().fullscreen ? 'close-big' : 'close'"/>
      </button>
    }
  </div>
</div>
